import { useState, useEffect } from 'react';
import './styles/darkModeSwitch.css';

const DarkModeSwitch = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  // Check user's preferred theme from localStorage or system preference
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    const initialTheme = savedTheme || (prefersDark ? 'dark' : 'light');
    if (initialTheme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
      setIsDarkMode(true);
    } else {
      document.documentElement.removeAttribute('data-theme');
      setIsDarkMode(false);
    }
  }, []);

  // Toggle dark mode with animation
  const toggleDarkMode = () => {
    setIsAnimating(true);
    
    const newTheme = isDarkMode ? 'light' : 'dark';
    
    if (newTheme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    
    localStorage.setItem('theme', newTheme);
    
    // Reset animation state after animation completes
    setTimeout(() => {
      setIsAnimating(false);
      setIsDarkMode(!isDarkMode);
    }, 300);
  };

  return (
    <button 
      className={`dark-mode-switch ${isAnimating ? 'animating' : ''}`}
      onClick={toggleDarkMode}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className={`dark-mode-icon ${isDarkMode ? 'sun' : 'moon'} ${isAnimating ? 'rotate' : ''}`}>
        {isDarkMode ? '☀️' : '🌙'}
      </span>
    </button>
  );
};

export default DarkModeSwitch;